module.exports = __webpack_public_path__ + "img/lt08.34ec0d26.webp";